import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Locales
import { alemao } from "./languages/alemao";
import { chines } from "./languages/chines";
import { espanhol } from "./languages/espanhol";
import { frances } from "./languages/frances";
import { grego } from "./languages/grego";
import { holandes } from "./languages/holandes";
import { hungaro } from "./languages/hungaro";
import { indonesio } from "./languages/indonesio";
import { ingles } from "./languages/ingles";
import { italiano } from "./languages/italiano";
import { japones } from "./languages/japones";
import { polones } from "./languages/polones";
import { portugues_portugal } from "./languages/portugues-portugal";
import { portugues_brasil } from "./languages/portugues-brasil";
import { romeno } from "./languages/romeno";
import { russo } from "./languages/russo";
import { tcheco } from "./languages/tcheco";
import { turco } from "./languages/turco";

const setLang = localStorage.getItem("SPICY_LANG");

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  de: { translation: alemao },
  zh: { translation: chines },
  es: { translation: espanhol },
  fr: { translation: frances },
  gr: { translation: grego },
  nl: { translation: holandes },
  hu: { translation: hungaro },
  id: { translation: indonesio },
  en: { translation: ingles },
  it: { translation: italiano },
  ja: { translation: japones },
  pl: { translation: polones },
  "pt-PT": { translation: portugues_portugal },
  "pt-BR": { translation: portugues_brasil },
  ro: { translation: romeno },
  ru: { translation: russo },
  cs: { translation: tcheco },
  tr: { translation: turco },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    supportedLngs: [
      "de",
      "zh",
      "es",
      "fr",
      "gr",
      "nl",
      "hu",
      "id",
      "en",
      "it",
      "ja",
      "pl",
      "pt-PT",
      "pt-BR",
      "ro",
      "ru",
      "cs",
      "tr",
    ],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    lng: setLang || undefined,
  });

export default i18n;
